import React from 'react';
import './LegalPages.css';

const MentionsLegales = ({ setCurrentPage }) => {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Mentions légales</h1>
        
        <section>
          <h2>Éditeur du site</h2>
          <p>
            Ce site web est édité par un particulier à titre personnel. Il peut afficher des publicités via Google AdSense générant des revenus afin de financer les coûts d'hébergement et de maintenance.
          </p>
          <p>
            <strong>Nom du site :</strong> SoundNest<br />
            <strong>URL :</strong> {window.location.origin}<br />
            <strong>Type d'activité :</strong> Plateforme de découverte de sons libres de droits
          </p>
        </section>

        <section>
          <h2>Hébergement</h2>
          <p>
            Ce site est hébergé par un service d'hébergement web (Vercel, Netlify ou similaire). 
            L'hébergeur peut être contacté à l'adresse de son siège social pour toute question 
            relative à l'hébergement du site.
          </p>
        </section>

        <section>
          <h2>Contenu et propriété intellectuelle</h2>
          <h3>Code source</h3>
          <p>
            Le code source de ce site est développé en <strong>React</strong> et utilise 
            les bibliothèques open source suivantes :
          </p>
          <ul>
            <li><strong>React</strong> (v18.3.1) - Licence MIT</li>
            <li><strong>React DOM</strong> (v18.3.1) - Licence MIT</li>
            <li><strong>React Icons</strong> (v5.5.0) - Licence MIT</li>
            <li><strong>React Scripts</strong> (v5.0.1) - Licence MIT</li>
          </ul>

          <h3>Contenus audio</h3>
          <p>
            <strong>Important :</strong> Tous les sons disponibles sur SoundNest sont hébergés 
            par <strong>LaSonotheque.org</strong>. SoundNest ne stocke aucun fichier audio 
            sur ses propres serveurs.
          </p>
          <p>
            Les sons sont diffusés en streaming et téléchargés directement depuis les serveurs 
            de LaSonotheque.org. Les droits d'utilisation de ces sons sont régis par les 
            conditions d'utilisation de LaSonotheque.org et leurs licences respectives 
            (généralement Creative Commons).
          </p>
        </section>

        <section>
          <h2>Responsabilité</h2>
          <p>
            L'éditeur s'efforce de fournir des informations aussi précises que possible. 
            Toutefois, il ne pourra être tenu responsable des omissions, des inexactitudes 
            et des carences dans la mise à jour, qu'elles soient de son fait ou du fait 
            des tiers partenaires qui lui fournissent ces informations.
          </p>
          <p>
            L'éditeur ne peut être tenu responsable de l'utilisation faite des contenus 
            audio fournis par LaSonotheque.org. Il appartient à chaque utilisateur de 
            vérifier les conditions d'utilisation spécifiques à chaque son.
          </p>
        </section>

        <section>
          <h2>Données personnelles</h2>
          <p>
            Ce site ne collecte aucune donnée personnelle. Les favoris et préférences 
            sont stockés localement dans votre navigateur via le localStorage et ne 
            sont jamais transmis à nos serveurs.
          </p>
          <p>
            Pour plus d'informations, consultez notre 
            <button className="inline-link" onClick={() => setCurrentPage('politique-confidentialite')}>
              politique de confidentialité
            </button>.
          </p>
        </section>

        <section>
          <h2>Cookies et publicité</h2>
          <p>
            Ce site utilise Google AdSense pour afficher des publicités. Ces services 
            peuvent déposer des cookies à des fins publicitaires. L'utilisation de ces 
            cookies est soumise aux politiques de confidentialité de Google.
          </p>
        </section>

        <section>
          <h2>Droit applicable</h2>
          <p>
            Les présentes mentions légales sont soumises au droit français. 
            En cas de litige, les tribunaux français seront seuls compétents.
          </p>
        </section>

        <section>
          <h2>Modification des mentions légales</h2>
          <p>
            L'éditeur se réserve le droit de modifier les présentes mentions légales 
            à tout moment. Il est conseillé de les consulter régulièrement.
          </p>
          <p>
            <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}
          </p>
        </section>
      </div>
    </div>
  );
};

export default MentionsLegales;
